import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Form, Radio, Tag } from "antd";
import { useMemo } from "react";
import { ERcbTier, EUserRole, ServiceTemplateField, TRANSLATABLE_METADATA_TEMPLATE_ATTRIBUTES_LIST, TemplateMetaDataField } from "@devowl-wp/api-real-cookie-banner";
import { useTranslation } from "../../../../../others/i18n.js";
import { service } from "../../../../../styles/service.js";
import { isSwitchableTier } from "../../../../../util/template/tier.js";
import { getFieldNameTranslated } from "../../../../../util/template/translation.js";
import { FormFieldVisibilityWrapper } from "../formFieldVisibilityWrapper.js";
/**
 * Form field for the tier of the template.
 * This field allows users to select the tier of the template.
 *
 * Exception: When CDN is enabled, the tier is automatically set to FREE and cannot be changed.
 *
 * @returns The form field component for tier.
 */ function FormFieldTemplateTier({ onTierChange }) {
    const { t } = useTranslation();
    const tierRules = useMemo(()=>[
            {
                required: true,
                message: t("Please choose a tier.")
            }
        ], [
        t
    ]);
    const form = Form.useFormInstance();
    const isCdn = Form.useWatch(ServiceTemplateField.IsCdn, form);
    return /*#__PURE__*/ _jsx(FormFieldVisibilityWrapper, {
        fieldNames: TemplateMetaDataField.Tier,
        permissionCheck: {
            whenRole: EUserRole.Translator,
            roleWhiteList: TRANSLATABLE_METADATA_TEMPLATE_ATTRIBUTES_LIST
        },
        children: /*#__PURE__*/ _jsx(Form.Item, {
            label: getFieldNameTranslated(TemplateMetaDataField.Tier, t),
            extra: t("Define, if this template is included in the free or pro version of Real Cookie Banner."),
            shouldUpdate: (prev, next)=>prev.extends?.identifier !== next.extends?.identifier || prev[ServiceTemplateField.IsCdn] !== next[ServiceTemplateField.IsCdn],
            required: true,
            children: ({ getFieldValue })=>{
                const extended = getFieldValue(TemplateMetaDataField.Extends);
                return /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        extended && extended.tier === ERcbTier.Pro ? /*#__PURE__*/ _jsxs("span", {
                            children: [
                                t("When extending from a PRO template this is calculated automatically."),
                                /*#__PURE__*/ _jsx("br", {})
                            ]
                        }) : isCdn ? /*#__PURE__*/ _jsxs("span", {
                            children: [
                                t("When service is a CDN, the tier is automatically set to FREE and cannot be changed."),
                                /*#__PURE__*/ _jsx("br", {})
                            ]
                        }) : "",
                        /*#__PURE__*/ _jsx(Form.Item, {
                            name: TemplateMetaDataField.Tier,
                            rules: tierRules,
                            noStyle: true,
                            children: /*#__PURE__*/ _jsxs(Radio.Group, {
                                onChange: (event)=>onTierChange?.(event.target.value),
                                disabled: isCdn,
                                children: [
                                    /*#__PURE__*/ _jsx(Radio, {
                                        value: ERcbTier.Free,
                                        disabled: isCdn || extended && !isSwitchableTier(extended.tier, ERcbTier.Free),
                                        children: /*#__PURE__*/ _jsx(Tag, {
                                            color: service.tier.free.color,
                                            children: t("FREE")
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Radio, {
                                        value: ERcbTier.Pro,
                                        disabled: isCdn || extended && !isSwitchableTier(extended.tier, ERcbTier.Pro),
                                        children: /*#__PURE__*/ _jsx(Tag, {
                                            color: service.tier.pro.color,
                                            children: t("PRO")
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                });
            }
        })
    });
}
export { FormFieldTemplateTier };
